import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-final-form";

import "../../styles/Wizard.css";
import { sendFormPages } from "../../services/sendFormPages/sendFormPages";
import axiosBase from "../../utils/axios/axios";
import { Link } from "react-router-dom";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";

const { SATISFACTION_SURVEY, SURVEY } = getEnvVariables();

export default class Wizard extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        onPageChange: PropTypes.func,
    };

    static Page = ({ children }) => children;

    constructor(props) {
        super(props);
        const numbe = localStorage.getItem("ultimo_paso");
        this.state = {
            page: parseInt(numbe),
            values: props.initialValues || {},
            typeButton: "",
            errorMessage: "",
            error: false,
            loading: false,
            save: false,
            radicado: "",
            urlSurvey: "",
        };
        this.props.onPageChange(parseInt(numbe));
    }

    getIsEdit() {
        return localStorage.getItem("isEdit") == "true";
    }
    getStateReturn() {
        return localStorage.getItem("estado") == "DEVUELTA";
    }
    getSaveEdit() {
        return localStorage.getItem("saveEdit") == "true";
    }
    getLastStep() {
        return localStorage.getItem("ultimo_paso");
    }
    setTypeButton(typeButton) {
        this.setState((state) => ({
            typeButton,
        }));
    }
    setErrorMessage(errorMessage, error) {
        this.setState((state) => ({
            errorMessage,
            error,
        }));
    }

    next = async (values) => {
        const next = this.state.page + 1;
        this.setErrorMessage("", false);
        this.setState((state) => ({
            page: state.page === 6 ? state.page : next,
            values,
        }));
        this.props.onPageChange(next);
    };
    previous = () => {
        const previous = this.state.page - 1;
        this.setErrorMessage("", false);
        this.setState((state) => ({
            page: state.page === 1 ? 1 : previous,
        }));
        this.props.onPageChange(previous);
    };

    validate = (values) => {
        const currentIndex = this.state.page - 1;

        const activePage = React.Children.toArray(this.props.children)[
            currentIndex
        ];
        if (this.state.page <= 5) {
            localStorage.removeItem("ready");
            localStorage.removeItem("dataLastStep");
        }
        if (this.state.page == 6 && localStorage.getItem("ready") != "true") {
            activePage.props.loadConfig();
        }
        return activePage?.props?.validate
            ? activePage?.props?.validate(values)
            : {};
    };
    handleSubmit = async (values) => {
        console.log("Se va por acá")
        const documento = localStorage.getItem("documento");
        const typeButton = this.state.typeButton;
        const currentPage = this.state.page;

        let dniData;

        if (!this.getIsEdit()) {
            console.log("Entra a la promesa");
            dniData = await axiosBase
                .get(`/personas/paso-uno/consulta/${documento}`)
                .catch(() => null);

            if (localStorage.getItem("ultimo_paso") > 1) {
                dniData = null;
            }
        }

        if (dniData && !dniData.error) {
            this.setErrorMessage(
                "El número de identificación ingresado ya tiene un trámite en proceso.",
                true
            );
            return;
        }

        if (typeButton === "next") {
            if (this.getLastStep() < currentPage) {
                this.setErrorMessage(
                    "Aún no se ha guardado la información. Primero guardar y después hacer clic en siguiente.",
                    true
                );
            } else this.next(values);
            return;
        }

        const { children, onSubmit } = this.props;
        const { page } = this.state;

        this.setState((state) => ({ loading: true }));
        const isLastPage = page === React.Children.count(children);
        const message = typeButton === "save" ? "guardado" : "actualizado";
        if (isLastPage) {
            sendFormPages(values, currentPage, typeButton)
                .then((response) => {
                    if (response.success) {
                        onSubmit(values);
                        this.setErrorMessage(
                            `Trámite finalizado con exito.`,
                            false
                        );
                        this.setState((state) => ({
                            save: true,
                            radicado: response.radicado,
                            urlSurvey: `${SATISFACTION_SURVEY}${SURVEY}&idt=${response.uuid}`,
                        }));
                    }
                })
                .finally(() => {
                    this.setState((state) => ({ loading: false }));
                });
            return;
        }
        sendFormPages(values, currentPage, typeButton)
            .then((formIsValid) => {
                if (formIsValid === true) {
                    const currentPage = this.state.page;
                    if (currentPage >= this.getLastStep()) {
                        localStorage.setItem("ultimo_paso", currentPage + 1);
                    }
                    this.setErrorMessage(
                        `Se ha ${message} la información de forma exitosa.`,
                        false
                    );
                } else if (formIsValid === false) {
                    this.setErrorMessage(
                        `No se ha ${message} la información. Por favor, intentelo más tarde.`,
                        true
                    );
                } else {
                    this.setErrorMessage(formIsValid, true);
                }
            })
            .finally(() => {
                this.setState((state) => ({ loading: false }));
            });
    };
    closeModal() {
        window.location.href = "/";
        localStorage.clear();
    }

    render() {
        const { children } = this.props;
        const { page, values } = this.state;

        const currentIndex = page - 1;
        const activePage = React.Children.toArray(children)[currentIndex];

        const isLastPage = page === React.Children.count(children);
        const currentPage = page;
        const isEdit = this.getIsEdit();

        const saveEdit = this.getSaveEdit();
        console.log("Wizard Render: isEdit=", this.getIsEdit(), "saveEdit=", this.getSaveEdit(), "estado=", localStorage.getItem("estado"), "page=", page);
        if (this.getStateReturn() && !this.getIsEdit()) {
            localStorage.setItem("isEdit", "true");
            localStorage.setItem("saveEdit", "false");
            console.log("Wizard Render: Forzando isEdit=true porque es DEVUELTA (después de navegación)");
            // Re-render para aplicar cambio
            this.forceUpdate();
        }

        return (
            <div>
                <Form
                    initialValues={values}
                    validate={(values) => {
                        return this.validate(values);
                    }}
                    onSubmit={this.handleSubmit}
                >
                    {({ handleSubmit, submitting, values }) => (
                        <form onSubmit={handleSubmit}>
                            {activePage}
                            <div className="buttons-content mt-4">
                                {page > 1 && (
                                    <button
                                        type="button"
                                        className="btn btn-round btn-high boton-inicio"
                                        onClick={this.previous}
                                    >
                                        « Anterior
                                    </button>
                                )}
                                {isEdit && !saveEdit && (
                                    <button
                                        name="edit"
                                        type="submit"
                                        className="btn btn-round btn-high boton-inicio"
                                        onClick={(event) =>
                                            this.setTypeButton(
                                                event.target.name
                                            )
                                        }
                                    >
                                        {!isLastPage
                                            ? "Editar"
                                            : "Enviar trámite a la entidad"}
                                    </button>
                                )}
                                {!isEdit && (
                                    <button
                                        name="save"
                                        type="submit"
                                        className="btn btn-round btn-high boton-inicio"
                                        onClick={(event) =>
                                            this.setTypeButton(
                                                event.target.name
                                            )
                                        }
                                    >
                                        {!isLastPage
                                            ? "Guardar"
                                            : "Enviar trámite a la entidad"}
                                    </button>
                                )}
                                {!isLastPage && (
                                    <button
                                        name="next"
                                        type="submit"
                                        className="btn btn-round btn-high boton-inicio"
                                        onClick={(event) =>
                                            this.setTypeButton(
                                                event.target.name
                                            )
                                        }
                                        disabled={
                                            this.getLastStep() < currentPage + 1
                                        }
                                    >
                                        Siguiente »
                                    </button>
                                )}
                            </div>
                            {this.state.errorMessage !== "" && (
                                <div
                                    style={{
                                        marginTop: "20px",
                                        color: "#464646",
                                        fontSize: "15px",
                                    }}
                                    className={
                                        this.state.error
                                            ? "alert alert-danger"
                                            : "alert alert-success"
                                    }
                                    role="alert"
                                >
                                    {this.state.errorMessage}
                                </div>
                            )}
                            {
                                <div className="steps lead text-center mt-3">
                                    Paso {page} de 6
                                </div>
                            }
                        </form>
                    )}
                </Form>
                {this.state.loading && (
                    <div
                        className="modal"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "block" }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                        >
                            <div class="loader" role="status">
                                <span class="visually-hidden text-4xl text-white">
                                    Su solicitud esta siendo procesada, por
                                    favor espera un momento...
                                </span>
                                <div class="spinner"></div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.save && (
                    <div
                        className="modal"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "block" }}
                    >
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5
                                        class="modal-title fs-5"
                                        id="exampleModalLabel"
                                    >
                                        Tramite radicado
                                    </h5>
                                </div>
                                <div class="modal-body">
                                    {!isEdit
                                        ? `Su solicitud fue radicada con el número ${this.state.radicado}. Puede consultar su estado desde la opción Consultar trámite`
                                        : "Su solicitud fue enviada a la entidad"}
                                </div>
                                <div class="modal-footer d-flex justify-content-between flex-column">
                                    <button
                                        type="button"
                                        class="btn btn-round btn-high mb-2"
                                        onClick={this.closeModal}
                                    >
                                        Aceptar
                                    </button>
                                    {!isEdit ? (
                                        <div className="pt-2">
                                            <Link
                                                to={this.state.urlSurvey}
                                                target="_blank"
                                            >
                                                <button className="btn btn-round btn-high mt-2">
                                                    ENCUESTA DE SATISFACCIÓN
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
